'use es6';

export const rich_text = 'rich_text';
export const raw_html = 'raw_html';
export const form = 'form';